import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComics() {
  const hotComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100" aria-label="热门漫画">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs font-medium text-primary-600 uppercase tracking-widest">
              Popular
            </span>
            <h2 className="text-2xl md:text-4xl font-display font-bold text-foreground-950 mt-2">
              热门推荐
            </h2>
          </div>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group flex flex-col cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 在线免费阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-50">
                  {comic.status}
                </div>
                <div className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded-full bg-foreground-950/70 text-background-50 text-xs font-bold">
                  {idx + 1}
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-accent-600 flex items-center gap-0.5">
                  <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
                  {comic.rating}
                </span>
                <span className="text-xs text-foreground-500">
                  {comic.category}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}